export const FETCH_SURVEY_TEMPLATES_REQUEST = 'FETCH_SURVEY_TEMPLATES_REQUEST';
export const FETCH_SURVEY_TEMPLATES_SUCCESS = 'FETCH_SURVEY_TEMPLATES_SUCCESS';
export const FETCH_SURVEY_TEMPLATES_FAILURE = 'FETCH_SURVEY_TEMPLATES_FAILURE';

export const FETCH_SURVEY_TEMPLATE_REQUEST = 'FETCH_SURVEY_TEMPLATE_REQUEST';
export const FETCH_SURVEY_TEMPLATE_SUCCESS = 'FETCH_SURVEY_TEMPLATE_SUCCESS';
export const FETCH_SURVEY_TEMPLATE_FAILURE = 'FETCH_SURVEY_TEMPLATE_FAILURE';

export const CREATE_SURVEY_TEMPLATE_REQUEST = 'CREATE_SURVEY_TEMPLATE_REQUEST';
export const CREATE_SURVEY_TEMPLATE_SUCCESS = 'CREATE_SURVEY_TEMPLATE_SUCCESS';
export const CREATE_SURVEY_TEMPLATE_FAILURE = 'CREATE_SURVEY_TEMPLATE_FAILURE';

export const UPDATE_SURVEY_TEMPLATE_REQUEST = 'UPDATE_SURVEY_TEMPLATE_REQUEST';
export const UPDATE_SURVEY_TEMPLATE_SUCCESS = 'UPDATE_SURVEY_TEMPLATE_SUCCESS';
export const UPDATE_SURVEY_TEMPLATE_FAILURE = 'UPDATE_SURVEY_TEMPLATE_FAILURE';

export const DELETE_SURVEY_TEMPLATE_REQUEST = 'DELETE_SURVEY_TEMPLATE_REQUEST';
export const DELETE_SURVEY_TEMPLATE_SUCCESS = 'DELETE_SURVEY_TEMPLATE_SUCCESS';
export const DELETE_SURVEY_TEMPLATE_FAILURE = 'DELETE_SURVEY_TEMPLATE_FAILURE';